import classNames from 'classnames';
import { benefitsIcons } from '../../../constants/icons';
import Title from '../../Atoms/Title';

import styles from './GridBenefits.module.css';

function GridBenefits() {
  return (
    <div
      className={classNames([
        'grid grid-cols-2 gap-x-3 gap-y-16 md:grid-cols-3 md:gap-y-20',
        styles.grid
      ])}
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="mb-2 flex h-14 shrink-0 basis-14 items-center justify-center lg:mb-0 lg:mr-5 lg:h-auto lg:basis-24">
          {benefitsIcons.conditions}
        </div>
        <Title
          color="blue"
          as="h4"
          weight={500}
          className="text-center lg:text-left"
        >
          <span className="flex flex-col text-sm !leading-tight xsm:text-xl sm:text-2xl xl:text-3xl">
            <span>good working </span>
            <span>conditions</span>
          </span>
        </Title>
      </div>
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="mb-2 flex h-14 shrink-0 basis-14 items-center justify-center lg:mb-0 lg:mr-5 lg:h-auto lg:basis-24">
          {benefitsIcons.bonuses}
        </div>
        <Title
          color="blue"
          as="h4"
          weight={500}
          className="flex flex-col text-center lg:text-left"
        >
          <span className="flex flex-col text-sm !leading-tight xsm:text-xl sm:text-2xl xl:text-3xl">
            <span>performance </span>
            <span>bonuses</span>
          </span>
        </Title>
      </div>
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="mb-2 flex h-14 shrink-0 basis-14 items-center justify-center lg:mb-0 lg:mr-5 lg:h-auto lg:basis-24">
          {benefitsIcons.food}
        </div>
        <Title
          color="blue"
          as="h4"
          weight={500}
          className="flex flex-col text-center lg:text-left"
        >
          <span className="flex flex-col text-sm !leading-tight xsm:text-xl sm:text-2xl xl:text-3xl">
            <span>lunch and fruit </span>
            <span>from the business</span>
          </span>
        </Title>
      </div>
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="mb-2 flex h-14 shrink-0 basis-14 items-center justify-center lg:mb-0 lg:mr-5 lg:h-auto lg:basis-24">
          {benefitsIcons.drinks}
        </div>
        <Title
          color="blue"
          as="h4"
          weight={500}
          className="flex flex-col text-center lg:text-left"
        >
          <span className="flex flex-col text-sm !leading-tight xsm:text-xl sm:text-2xl xl:text-3xl">
            <span>borrels </span>
            <span>en feestjes</span>
          </span>
        </Title>
      </div>
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="mb-2 flex h-14 shrink-0 basis-14 items-center justify-center lg:mb-0 lg:mr-5 lg:h-auto lg:basis-24">
          {benefitsIcons.training}
        </div>
        <Title
          color="blue"
          as="h4"
          weight={500}
          className="flex flex-col text-center lg:text-left"
        >
          <span className="flex flex-col text-sm !leading-tight xsm:text-xl sm:text-2xl xl:text-3xl">
            <span>training en </span>
            <span>ontwikkeling</span>
          </span>
        </Title>
      </div>
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="mb-2 flex h-14 shrink-0 basis-14 items-center justify-center lg:mb-0 lg:mr-5 lg:h-auto lg:basis-24">
          {benefitsIcons.phone}
        </div>
        <Title
          color="blue"
          as="h4"
          weight={500}
          className="flex flex-col text-center lg:text-left"
        >
          <span className="flex flex-col text-sm !leading-tight xsm:text-xl sm:text-2xl xl:text-3xl">
            <span>telefoon </span>
            <span>van de zaak</span>
          </span>
        </Title>
      </div>
    </div>
  );
}

export default GridBenefits;
